import { render, staticRenderFns } from "./ModalOtherCost.vue?vue&type=template&id=2273c9a6"
import script from "./ModalOtherCost.vue?vue&type=script&lang=js"
export * from "./ModalOtherCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports